<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="ACTIVE GC ITEMS"
                                type="gradient-green"
                                :sub-title="active_Count"
                                icon="fas fa-check"
                                class="mb-3 mb-xl-0">
                    </stats-card>
                </div>
               <div class="col-xl-4 col-lg-6">
                    <stats-card title="INACTIVE GC ITEMS"
                                type="gradient-orange"
                                :sub-title="inactive_Count"
                                icon="fas fa-times"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="DELETED GC ITEMS"
                                type="gradient-red"
                                :sub-title="deleted_Count"
                                icon="fas fa-trash"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>
        
        <div class="container-fluid mt--7">
            <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                    <div class="col-md-12" style="height: 100vh;">
                        <a-tabs v-model:activeKey="activeKey">
                            <a-tab-pane tab="Gift Certificate Dashboard" key="1">
                                <div class="ml-3 mt-3 mr-3">
                                    <gift-certificates @changeGC="changeGC($event)" />
                                </div>  
                            </a-tab-pane>
                            <a-tab-pane :tab="tab2_label" key="2">
                                <a-spin :spinning="spinning" :tip="spinning_tip">
                                <div class="ml-3 mt-3 mr-3">
                                    <!-- {{GC Codes Table}} -->
                                    <div class="row no-gutters">
                                        <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                                        <div class="card-body">
                                            <filter-bar @changeFilter="changeFilter" :key="statusKey"></filter-bar>
                                        </div>
                                        </div>

                                        <div class="col-md-9">
                                        <div class="card-body">
                                            <backend-profiles-table :key="formKey" :accessRights="accessRights" :gcDetails="gcDetails"></backend-profiles-table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                </a-spin>
                            </a-tab-pane>
                        </a-tabs>
                        <br><br>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import GiftCertificates from '../Gift Certificates/GiftCertificates.vue'
import BackendProfilesTable from '../Tables/BackendProfilesTable.vue'
import FilterBar from './../FilterBar'
import { mapState, mapActions } from 'vuex'
import secureStorage from '../../controllers/secureStorage';

export default {
    components: {
        GiftCertificates,
        BackendProfilesTable,
        FilterBar
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    data() { 
        return {
            spinning: false,
            spinning_tip: '',
            view_mode: false,
            gc_update_id: 0,
            gc_value: 0,
            activeKey: '1',
            active_Count: "0",
            inactive_Count: "0",
            deleted_Count: "0",
            tab2_label: "",
            errors: [],
            profileId: null,
            accessRights: [],
            gcDetails: [],
            statusKey: 0,
            formKey: 0,
            activeModules: [],
        }
    },
    watch: {
        
    },
    methods: {
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        async changeGC(e) {
            this.spinning = true
            this.spinning_tip = "Fetching GC codes..."
            var i = e.split('|')
            this.activeKey = '2';
            this.tab2_label = i[1]
            this.gc_update_id = i[0]
            this.gc_value = i[2]
            this.errors = [];
            //Load GC Codes
            this.updateParameters("?product_id=" + this.gc_update_id + "&gc_value=" + this.gc_value)
            this.statusKey++
            this.formKey++
            this.spinning = false
        },
        
        validateForm() {
            this.errors = [];
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        async getGCStatusCount(status){
            var gcstat = await HTTPRequest.getRequest(this.endPoint + "/products?type=gift_certificate&status=" + status , null, null)
            if (gcstat != null) {
                
                if (status == 'A') {
                    this.active_Count = gcstat.total.toString()
                } else if(status == 'I') {
                    this.inactive_Count = gcstat.total.toString()
                } else {
                    this.deleted_Count = gcstat.total.toString()
                }
            }
        },
        async setCurrentProfile(profile, id){
            var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
            if (_.isEmpty(accessRightsRequest.access_rights) == false){
                this.accessRights = accessRightsRequest.access_rights[id]
            }else {
                this.accessRights = []
            }
           
            this.updateCurrentProfile(profile)
            this.statusKey++
            this.formKey++;
        },
        changeFilter(statusFilter, searchFilter, searchText){
          if(statusFilter == "0"){
              this.updateParameters("?product_id=" + this.gc_update_id + "&" + searchFilter + "=" + searchText)
          } else {
              this.updateParameters("?product_id=" + this.gc_update_id + "&" + searchFilter + "=" + searchText + "&status="+statusFilter)
          }
        },
    },
    mounted: async function(){
       await this.getGCStatusCount('A');
       await this.getGCStatusCount('I');
       await this.getGCStatusCount('D');

        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MDM-005', null, null)
        this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)

        if( this.activeModules.length > 0 ){
            this.setCurrentProfile('gift_certificates', this.activeModules[0].id);
        } else {
            this.setCurrentProfile('gift_certificates',  null)
            this.formKey++
        }
    }
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>